import { Model, RailsFormat } from "./model";
import { Contact } from "./contact";
import { Window } from "./window";
import { Course } from "./course";
import { TutorAllocation } from "./tutor-allocation";

export class Booking extends Model implements RailsFormat {

  constructor(
    public id?: number,
    public contactId?: number,
    public windowId?: number,
    public courseId?: number,
    public tutorAllocationId?: number,
    public previousTutorAllocationId?: number,

    public period: number = null,
    public date: Date = null,

    public contact: Contact = null,
    public window: Window = null,
    public course: Course = null,

    public tutorAllocation: TutorAllocation = null,

    public note: String = null,

    public createdAt: Date = null,
    public updatedAt: Date = null,
  ) { super() }

  static clone(obj: any) {
    const b = new this()

    if (obj.id) { b.id = obj.id }
    if (obj.contactId) { b.contactId = obj.contactId }
    if (obj.windowId) { b.windowId = obj.windowId }
    if (obj.courseId) { b.courseId = obj.courseId }
    if (obj.tutorAllocationId) { b.tutorAllocationId = obj.tutorAllocationId }

    if (obj.period) { b.period = obj.period }
    if (obj.date) { b.date = new Date(obj.date) }

    if (obj.contact) { b.contact = Contact.clone(obj.contact) }
    if (obj.window) { b.window = Window.clone(obj.window) }
    if (obj.course) { b.course = Course.clone(obj.course) }

    if (obj.note) { b.note = obj.note }

    if (obj.tutorAllocation) {
      b.tutorAllocation = TutorAllocation.clone(obj.tutorAllocation) }

    if (obj.createdAt) { b.createdAt = new Date(obj.createdAt) }
    if (obj.updatedAt) { b.updatedAt = new Date(obj.updatedAt) }

    return b
  }

  serializeForRails(): Booking {
    const response: any = Object.assign({}, this) 
    
    if (this.id === 0) { response.id = null }

    return response
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/models/booking.ts